import { setJwtToken } from "./apiClient";

import { groupsApi } from "./groups";
import { savingsSourcesApi } from "./savingsSources";
import { expensesListsApi } from "./expensesLists";
import { expensesApi } from "./expenses";
import { widgetsApi } from "./widgets";
import { categoriesApi } from "./categories";
import { capitalApi } from "./capital";
import { customStocksApi } from "./customStocks";
import { usersApi } from "./users";
import { encryptedNotesApi } from "./encryptedNotes";

export const api = {
  ...groupsApi,
  ...savingsSourcesApi,
  ...expensesListsApi,
  ...expensesApi,
  ...widgetsApi,
  ...categoriesApi,
  ...capitalApi,
  ...customStocksApi,
  ...usersApi,
  ...encryptedNotesApi,
};

export { setJwtToken };
